import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import useSWR from 'swr';

import axios from '../../admin-axios';
import { ReactComponent as PlusIcon } from '../../assets/Images/plus_icon.svg';
import { detectError } from '../../utils';
import classes from './index.module.scss';

const fetcher = (url) => axios.get(url).then((res) => res.data);

const Pricing = () => {
  const [customerView, setCustomerView] = useState('retailers');
  const [pricing, setPricing] = useState([]);
  // const [loadingPricing, setLoadingPricing] = useState(false);
  // const [error, setError] = useState('');
  const [formPricing, setFormPricing] = useState([]);
  const [endUserPricing, setEndUserPricing] = useState({});

  const {
    user: { stationId }
  } = useSelector((state) => state.auth);

  const {
    data,
    error,
    isLoading: loadingPricing,
    mutate
  } = useSWR(`/tiers/view/${stationId}`, fetcher);

  const {
    data: endUserData,
    error: endUserError,
    isLoading: loadingEndUserPricing
  } = useSWR(`/pricing/view/${stationId}`, fetcher);

  // useEffect(() => {
  //   const fetchTiers = async () => {
  //     try {
  //       setLoadingPricing(true);
  //       const { data } = await axios.get(`/tiers/view/${stationId}`);
  //       setPricing(data.data);
  //       setFormPricing(
  //         data.data.map((item) => ({
  //           id: item.id,
  //           min: item.min,
  //           max: item.max,
  //           price: item.price,
  //           loading: false
  //         }))
  //       );
  //       setLoadingPricing(false);
  //     } catch (e) {
  //       // console.log(error);
  //       setLoadingPricing(false);
  //       toast.error(detectError(e));
  //       setError(detectError(e));
  //     }
  //   };
  //   fetchTiers();
  // }, [stationId]);

  useEffect(() => {
    if (data) {
      setPricing(data.data);
      setFormPricing(
        data.data.map((item) => ({
          id: item.id,
          min: item.min,
          max: item.max,
          price: item.price,
          name: item.name,
          loading: false
        }))
      );
    }
  }, [data]);

  useEffect(() => {
    if (endUserData) {
      setEndUserPricing({
        ...endUserData.data[0],
        loading: false
      });
    }
  }, [endUserData]);

  const setTierData = async (index) => {
    const formData = formPricing[index];
    if (formData.id) {
      //   send request to update
      try {
        // check if any of the formData attributes are empty
        if (!formData.min || !formData.max || !formData.price) {
          toast.error('Please fill all fields');
          return;
        }

        setFormPricing((prev) => {
          const updated = [...prev];
          updated[index].loading = true;
          return updated;
        });
        await axios.patch(`/tiers/update/${formData.id}`, {
          gas_min: formData.min,
          gas_max: formData.max,
          price: formData.price,
          name: formData.name
        });
        setFormPricing((prev) => {
          const updated = [...prev];
          updated[index].loading = false;
          return updated;
        });
        toast.success('Tier updated successfully');
      } catch (e) {
        toast.error(detectError(e));

        setFormPricing((prev) => {
          const updated = [...prev];
          updated[index].loading = false;
          return updated;
        });
      }
      // console.log('update', formData);
    } else {
      //   send request to create
      try {
        // check if any of the formData attributes are empty
        if (!formData.min || !formData.max || !formData.price) {
          toast.error('Please fill all fields');
          return;
        }
        setFormPricing((prev) => {
          const updated = [...prev];
          updated[index].loading = true;
          return updated;
        });
        await axios.post(`/tiers/add`, {
          gas_min: formData.min,
          gas_max: formData.max,
          price: formData.price,
          name: formData.name,
          station_id: stationId
        });
        await mutate();

        toast.success('Tier created successfully');
      } catch (e) {
        toast.error(detectError(e));
        setFormPricing((prev) => {
          const updated = [...prev];
          updated[index].loading = false;
          return updated;
        });
      }
      // console.log('create', data);
    }
  };

  const setEndUserPrice = async () => {
    if (!endUserPricing.price || !endUserPricing.min || !endUserPricing.max) {
      toast.error('Please fill all fields');
      return;
    }

    if (endUserPricing.min > endUserPricing.max) {
      toast.error('Minimum value cannot be greater than maximum value');
      return;
    }

    if (endUserPricing.id) {
      //   send request to update
      try {
        setEndUserPricing((prev) => ({ ...prev, loading: true }));
        await axios.patch(`/pricing/update/${endUserPricing.id}`, {
          price: endUserPricing.price,
          gas_min: endUserPricing.min,
          gas_max: endUserPricing.max
        });
        toast.success('End user price updated successfully');
        await mutate();
        setEndUserPricing((prev) => ({ ...prev, loading: false }));
      } catch (e) {
        toast.error(detectError(e));
        setEndUserPricing((prev) => ({ ...prev, loading: false }));
      }
    } else {
      try {
        setEndUserPricing((prev) => ({ ...prev, loading: true }));
        await axios.post(`/pricing/create`, {
          price: endUserPricing.price,
          gas_min: endUserPricing.min,
          gas_max: endUserPricing.max,
          station_id: stationId
        });
        toast.success('End user price created successfully');
        await mutate();
        setEndUserPricing((prev) => ({ ...prev, loading: false }));
      } catch (e) {
        toast.error(detectError(e));
        setEndUserPricing((prev) => ({ ...prev, loading: false }));
      }
    }
  };

  useEffect(() => {
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className={classes.pricing}>
      <div className={`${classes.pricing_buttons} mt-3 mb-5`}>
        <button
          className="me-3"
          onClick={() => setCustomerView('retailers')}
          style={{
            backgroundColor: customerView === 'retailers' ? '#000000' : '#F0F0F0',
            color: customerView === 'retailers' ? '#FFF' : '#636060'
          }}
          type="button">
          Retailers
        </button>
        <button
          className=""
          onClick={() => setCustomerView('endusers')}
          style={{
            backgroundColor: customerView === 'endusers' ? '#000000' : '#F0F0F0',
            color: customerView === 'endusers' ? '#FFF' : '#636060'
          }}
          type="button">
          End Users
        </button>
      </div>

      {customerView === 'retailers' && (
        <>
          <div className={classes.pricing_table_wrapper}>
            <table className={`table ${classes.pricing_table}`}>
              <thead>
                <tr>
                  <th scope="col">Tier</th>
                  <th scope="col">Gas Quantity</th>
                  <th scope="col">Price</th>
                  <th scope="col">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {loadingPricing && (
                  <tr>
                    <td colSpan={4}>
                      <div className="d-flex justify-content-center w-100">
                        <Spinner className="spinner" animation="border" variant="dark" />
                      </div>
                    </td>
                  </tr>
                )}
                {error && (
                  <tr>
                    <td colSpan={4} className="w-100 text-center">
                      {detectError(error)}
                    </td>
                  </tr>
                )}
                {!loadingPricing &&
                  pricing &&
                  pricing.length > 0 &&
                  pricing.map((price, index) => (
                    <tr key={index}>
                      <td>
                        <div
                          className={`w-100 d-flex justify-content-start align-items-center ${classes.pricing_table_box}`}>
                          {price?.id ? (
                            <div className={`${classes.pricing_table_tier} mt-3`}>{price.name}</div>
                          ) : (
                            <div className="">
                              <p className="text-secondary fw-bold">Name</p>
                              <input
                                type="text"
                                className="p-2"
                                name={`name-${index}`}
                                value={formPricing[index].name || ''}
                                onChange={(e) => {
                                  const newFormPricing = [...formPricing];
                                  newFormPricing[index].name = e.target.value;
                                  setFormPricing(newFormPricing);
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center w-100 justify-content-start">
                          <div className="me-5">
                            <p className="text-secondary fw-bold">Min (KG).</p>
                            <input
                              type="text"
                              className="p-2"
                              name={`min-${index}`}
                              value={formPricing[index].min || ''}
                              onChange={(e) => {
                                const newFormPricing = [...formPricing];
                                newFormPricing[index].min = e.target.value;
                                setFormPricing(newFormPricing);
                              }}
                            />
                          </div>
                          <div>
                            <p className="text-secondary fw-bold">Max (KG).</p>
                            <input
                              type="text"
                              className="p-2"
                              name={`max-${index}`}
                              value={formPricing[index].max || ''}
                              onChange={(e) => {
                                const newFormPricing = [...formPricing];
                                newFormPricing[index].max = e.target.value;
                                setFormPricing(newFormPricing);
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div>
                          <p className="text-secondary fw-bold">Price/KG (NGN)</p>
                          <input
                            type="text"
                            className="p-2"
                            name={`price-${index}`}
                            value={formPricing[index].price || ''}
                            onChange={(e) => {
                              const newFormPricing = [...formPricing];
                              newFormPricing[index].price = e.target.value;
                              setFormPricing(newFormPricing);
                            }}
                          />
                        </div>
                      </td>
                      <td>
                        <button
                          type="button"
                          disabled={formPricing[index].loading}
                          onClick={() => setTierData(index)}
                          className={`btn mt-3 px-5 py-3 ${classes.pricing_table_set_button}`}>
                          Set
                        </button>
                      </td>
                    </tr>
                  ))}
                {!loadingPricing && pricing && pricing.length === 0 && (
                  <tr>
                    <td colSpan={4} className="w-100 text-center">
                      No pricing available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-end">
            <button
              onClick={() => {
                const newFormPricing = [...formPricing];
                newFormPricing.push({
                  min: '',
                  max: '',
                  price: '',
                  name: '',
                  loading: false
                });
                setFormPricing(newFormPricing);
                const newPricing = [...pricing];
                newPricing.push({
                  min: '',
                  max: '',
                  price: '',
                  name: 'Test'
                  // id: pricing.length + 1
                });
                setPricing(newPricing);
              }}
              className={`${classes.pricing_add_tier} btn py-3 px-5 mt-4`}
              type="button">
              <PlusIcon /> Add Tier
            </button>
          </div>
        </>
      )}

      {customerView === 'endusers' && (
        <div>
          <div className={classes.pricing_table_wrapper}>
            <table className={`table ${classes.pricing_table}`}>
              <thead>
                <tr>
                  <th scope="col">Gas Quantity</th>
                  <th scope="col">Price</th>
                  <th scope="col">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {loadingEndUserPricing && (
                  <tr>
                    <td colSpan={4}>
                      <div className="d-flex justify-content-center w-100">
                        <Spinner className="spinner" animation="border" variant="dark" />
                      </div>
                    </td>
                  </tr>
                )}
                {endUserError && (
                  <tr>
                    <td colSpan={4} className="w-100 text-center">
                      {detectError(endUserError)}
                    </td>
                  </tr>
                )}
                {!loadingEndUserPricing && pricing && (
                  <tr>
                    <td>
                      <div className="d-flex align-items-center w-100 justify-content-start">
                        <div className="me-5">
                          <p className="text-secondary fw-bold">Min (KG).</p>
                          <input
                            type="text"
                            className="p-2"
                            name="min-x5x"
                            value={endUserPricing.min || ''}
                            onChange={(e) => {
                              const newEndUserPricing = { ...endUserPricing };
                              newEndUserPricing.min = e.target.value;
                              setEndUserPricing(newEndUserPricing);
                            }}
                          />
                        </div>
                        <div>
                          <p className="text-secondary fw-bold">Max (KG).</p>
                          <input
                            type="text"
                            className="p-2"
                            name="max-x5x"
                            value={endUserPricing.max || ''}
                            onChange={(e) => {
                              const newEndUserPricing = { ...endUserPricing };
                              newEndUserPricing.max = e.target.value;
                              setEndUserPricing(newEndUserPricing);
                            }}
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div>
                        <p className="text-secondary fw-bold">Price/KG (NGN)</p>
                        <input
                          type="text"
                          className="p-2"
                          name="price-x5x"
                          value={endUserPricing.price || ''}
                          onChange={(e) => {
                            const newEndUserPricing = { ...endUserPricing };
                            newEndUserPricing.price = e.target.value;
                            setEndUserPricing(newEndUserPricing);
                          }}
                        />
                      </div>
                    </td>
                    <td>
                      <button
                        type="button"
                        disabled={endUserPricing.loading}
                        onClick={setEndUserPrice}
                        className={`btn mt-3 px-5 py-3 ${classes.pricing_table_set_button}`}>
                        Set
                      </button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {endUserPricing && !endUserPricing.id && (
            <div className="d-flex justify-content-end">
              <button
                onClick={() => {
                  setEndUserPricing({
                    min: '',
                    max: '',
                    price: '',
                    loading: false
                  });
                }}
                className={`${classes.pricing_add_tier} btn py-3 px-5 mt-4`}
                type="button">
                <PlusIcon /> Create Price
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Pricing;
